"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarginAll;
(function (MarginAll) {
    MarginAll["One"] = "ty-mg-1";
    MarginAll["Two"] = "ty-mg-2";
    MarginAll["Three"] = "ty-mg-3";
    MarginAll["Four"] = "ty-mg-4";
    MarginAll["Five"] = "ty-mg-5";
    MarginAll["Six"] = "ty-mg-6";
    MarginAll["Seven"] = "ty-mg-7";
    MarginAll["Auto"] = "ty-mg-auto";
    MarginAll["Zero"] = "ty-mg-zero";
})(MarginAll = exports.MarginAll || (exports.MarginAll = {}));
var MarginLeft;
(function (MarginLeft) {
    MarginLeft["One"] = "ty-mgl-1";
    MarginLeft["Two"] = "ty-mgl-2";
    MarginLeft["Three"] = "ty-mgl-3";
    MarginLeft["Four"] = "ty-mgl-4";
    MarginLeft["Five"] = "ty-mgl-5";
    MarginLeft["Six"] = "ty-mgl-6";
    MarginLeft["Seven"] = "ty-mgl-7";
    MarginLeft["Auto"] = "ty-mgl-auto";
    MarginLeft["Zero"] = "ty-mgl-zero";
})(MarginLeft = exports.MarginLeft || (exports.MarginLeft = {}));
var MarginTop;
(function (MarginTop) {
    MarginTop["One"] = "ty-mgt-1";
    MarginTop["Two"] = "ty-mgt-2";
    MarginTop["Three"] = "ty-mgt-3";
    MarginTop["Four"] = "ty-mgt-4";
    MarginTop["Five"] = "ty-mgt-5";
    MarginTop["Six"] = "ty-mgt-6";
    MarginTop["Seven"] = "ty-mgt-7";
    MarginTop["Auto"] = "ty-mgt-auto";
    MarginTop["Zero"] = "ty-mgt-zero";
})(MarginTop = exports.MarginTop || (exports.MarginTop = {}));
var MarginRight;
(function (MarginRight) {
    MarginRight["One"] = "ty-mgr-1";
    MarginRight["Two"] = "ty-mgr-2";
    MarginRight["Three"] = "ty-mgr-3";
    MarginRight["Four"] = "ty-mgr-4";
    MarginRight["Five"] = "ty-mgr-5";
    MarginRight["Six"] = "ty-mgr-6";
    MarginRight["Seven"] = "ty-mgr-7";
    MarginRight["Auto"] = "ty-mgr-auto";
    MarginRight["Zero"] = "ty-mgr-zero";
})(MarginRight = exports.MarginRight || (exports.MarginRight = {}));
var MarginBottom;
(function (MarginBottom) {
    MarginBottom["One"] = "ty-mgb-1";
    MarginBottom["Two"] = "ty-mgb-2";
    MarginBottom["Three"] = "ty-mgb-3";
    MarginBottom["Four"] = "ty-mgb-4";
    MarginBottom["Five"] = "ty-mgb-5";
    MarginBottom["Six"] = "ty-mgb-6";
    MarginBottom["Seven"] = "ty-mgb-7";
    MarginBottom["Auto"] = "ty-mgb-auto";
    MarginBottom["Zero"] = "ty-mg-zero";
})(MarginBottom = exports.MarginBottom || (exports.MarginBottom = {}));
